// src/api/url-route.ts

/**
 * Optional environment overrides (Vite):
 * - VITE_API_BASE_URL="http://localhost:8000/api" OR "https://yourdomain.com/api"
 * - VITE_WS_BASE_URL="ws://localhost:8000/api"  OR "wss://yourdomain.com/api"
 *
 * If not provided, it falls back to the current window.location-based logic.
 */

function stripTrailingSlash(url: string) {
  return url.endsWith("/") ? url.slice(0, -1) : url;
}

export function buildWsUrl() {
  const envWs = (import.meta as any)?.env?.VITE_WS_BASE_URL as string | undefined;
  if (envWs && typeof envWs === "string") return stripTrailingSlash(envWs);

  const { protocol, hostname } = window.location;

  // Local dev fallback
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return `ws://localhost:8000/api`;
  }

  // Deployed fallback
  const wsProtocol = protocol === "https:" ? "wss:" : "ws:";
  return `${wsProtocol}//${window.location.host}/api`;
}

export function buildApiUrl() {
  const envApi = (import.meta as any)?.env?.VITE_API_BASE_URL as string | undefined;
  if (envApi && typeof envApi === "string") return stripTrailingSlash(envApi);

  const { protocol, hostname } = window.location;

  // Local dev fallback
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return `http://localhost:8000/api`;
  }

  // Deployed fallback
  return `${protocol}//${window.location.host}/api`;
}
